import { useCallback, useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import styled from "styled-components";
import MainNav from "./MainNav";
import MobileMenu from "./MobileMenu";
import SiteFooter from "./SiteFooter";
import TopBar from "./TopBar";

const Page = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
`;

const SkipLink = styled.a`
  position: absolute;
  left: -9999px;
  z-index: ${({ theme }) => theme.zIndex.drawer};

  &:focus {
    left: 16px;
    top: 16px;
    padding: 10px 16px;
    background: ${({ theme }) => theme.colors.surface};
    border-radius: ${({ theme }) => theme.radii.sm};
    box-shadow: ${({ theme }) => theme.shadows.menu};
  }
`;

export function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuButtonRef = useRef(null);
  const { pathname } = useLocation();

  const closeMenu = useCallback(() => setMenuOpen(false), []);

  // Переход на другую страницу всегда закрывает мобильное меню.
  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  return (
    <Page>
      <SkipLink href="#main">К основному содержимому</SkipLink>

      <header>
        <TopBar />
        <MainNav
          menuButtonRef={menuButtonRef}
          onOpenMenu={() => setMenuOpen(true)}
        />
      </header>

      <MobileMenu
        open={menuOpen}
        onClose={closeMenu}
        returnFocusRef={menuButtonRef}
      />

      <Main id="main">
        <Outlet />
      </Main>

      <SiteFooter />
    </Page>
  );
}

export default Layout;
